import * as React from 'react';
import { translate } from 'utils/translateUtil';

import * as styles from './checkbox.scss';
import * as stylesBtn from 'components/buttons/button.scss';

import SVGCheck from 'components/svg/Check';

interface Props {
    toggleCheckBoxIsClicked: (activeField?: string) => void;
    checkBoxIsClicked: boolean;
    activeField?: string;
}

const Checkbox: React.SFC<Props> = props => {
    const onClickHandler = (event: any) => {
        const { toggleCheckBoxIsClicked } = props;
        event.preventDefault();
        toggleCheckBoxIsClicked();
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.btnWrapper} onClick={onClickHandler}>
                <button
                    className={
                        stylesBtn.btnDefault +
                        ' ' +
                        ' ' +
                        styles.checkboxWrapper
                    }
                >
                    <span
                        className={
                            styles.checkboxBtn +
                            ' ' +
                            (props.checkBoxIsClicked &&
                                ' ' + styles.checkboxActive)
                        }
                    >
                        <SVGCheck />
                    </span>
                    <p className={styles.checkboxText}>
                        {translate(
                            'main-page.checkbox'
                        )}
                    </p>
                </button>
            </div>
        </div>
    );
};

export default Checkbox;
